

import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Volunteer from "../pages/volunteer/page";
import Resources from "../pages/resources/page";
import Contact from "../pages/contact/page";
import Donate from "../pages/donate/page";
import StoriesPage from "../pages/Stories/page";
import DashboardPage from "../pages/dashboard/page";
import Login from "../pages/Login";
import ProtectedRoute from "../context/ProtectedRoute";
import OurWork from "../pages/ourWork/page";
import DonationPaymentPage from "../pages/donate/DonationPaymentPage";

const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/stories",
    element: <StoriesPage />,
  },
  {
    path: "/volunteer",
    element: <Volunteer />,
  },
  {
    path: "/resources",
    element: <Resources />,
  },
  {
    path: "/our-work",
    element: <OurWork />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/donate",
    element: <Donate />,
  },
  {
    path: "/donation/payment/:id",
    element: <DonationPaymentPage />,
  },
   {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardPage />,
      </ProtectedRoute>
    ),
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
